// Third-party Library 
import React, { useState, useMemo, useEffect } from "react";
import { Card, Col, Row } from "antd";

// Components
import MainPanel from "./MainPanel";
import SummaryCard from "./SidePanel/SummaryCard";
import DetailCard from "./SidePanel/DetailCard";

import { getLatestDataPerDate, buildDefaultEntry } from "./MainPanel/handlers";
import { parseDate, getCurTimeDayJS } from "../../../../services/util/time";

const Pretrip = (tableProps) => {

    const [ data, setData ] = useState({})
    const [ isOpenDrawer, setIsOpenDrawer ] = useState(null)

    const [ selectedDate, setSelectedDate ] = useState(getCurTimeDayJS())

    const dataReport = tableProps.dataReport || []
    const defaultSource = dataReport[0] || {}

    const dataSource = useMemo(() => getLatestDataPerDate(dataReport), [dataReport])

    useEffect(() => {
        const today = parseDate(getCurTimeDayJS())
        setData(dataSource[today] || buildDefaultEntry(defaultSource))
    }, [])

    const handleSelectDate = (date) => {
        const data = dataSource[parseDate(date)]
        setSelectedDate(date)
        setData(data || buildDefaultEntry(defaultSource, date))
    }

    return (
        <Row gutter={16}>
            <Col span={16}>
                <Card>
                    <MainPanel {...tableProps} dataSource={dataSource} selectedDate={selectedDate} handleSelectDate={handleSelectDate}/>
                </Card>
            </Col>
            <Col span={8}>
                <Card>
                    <SummaryCard dataSource={dataSource} {...tableProps}/>
                </Card>
                <br />
                <Card>
                    <DetailCard isOpenDrawer={isOpenDrawer} setIsOpenDrawer={setIsOpenDrawer} data={data} drawerPretripHDLR={tableProps.drawerPretripHDLR} ModalDriver={tableProps.ModalDriver} />
                </Card>
            </Col>
        </Row>
    )
}

export default React.memo(Pretrip)